module.exports = "/Public/build/68bafba75f4d07e401ca6ad12ec57b76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/cross.svg
// module id = 838
// module chunks = 0